import { AVAILABLE_LANGUAGES } from '@mission.io/mission-toolkit/constants'

const GOOGLE_TRANSLATE_URL: string =
	'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
const GOOGLE_TRANSLATE_COOKIE_NAME: string = 'googtrans'

export const LANGUAGE_TO_GOOGLE_LANGUAGE: {
	[language: $Keys<typeof AVAILABLE_LANGUAGES>]: string,
} = {
	[AVAILABLE_LANGUAGES.ENGLISH]: 'en',
	[AVAILABLE_LANGUAGES.SPANISH]: 'es',
	[AVAILABLE_LANGUAGES.PORTUGUESE]: 'pt',
	[AVAILABLE_LANGUAGES.FRENCH]: 'fr',
	[AVAILABLE_LANGUAGES.ARMENIAN]: 'hy',
	[AVAILABLE_LANGUAGES.RUSSIAN]: 'ru',
	[AVAILABLE_LANGUAGES.TAGALOG]: 'tl',
	[AVAILABLE_LANGUAGES.GERMAN]: 'de',
	[AVAILABLE_LANGUAGES.UKRAINIAN]: 'uk',
	[AVAILABLE_LANGUAGES.ARABIC]: 'ar',
	[AVAILABLE_LANGUAGES.CANTONESE]: 'yue',
	[AVAILABLE_LANGUAGES.JAPANESE]: 'ja',
	[AVAILABLE_LANGUAGES.KOREAN]: 'ko',
	[AVAILABLE_LANGUAGES.VIETNAMESE]: 'vi',
}

const googleAriaLabelSelector: Array<string> = [
	'Language Translate Widget',
	'Widget de idiomas del Traductor',
]

export { GOOGLE_TRANSLATE_URL, googleAriaLabelSelector, GOOGLE_TRANSLATE_COOKIE_NAME }
